<template>
    <div id="app" v-if="user || $route.meta.isAuthPage">
        <account-settings v-if="!$route.meta.isAuthPage && !$route.meta.isSubscribePage" />
        <sponsor-ad v-if="!$route.meta.isAuthPage && !$route.meta.isSubscribePage" />
        <router-view />
        <notifications position="bottom" class="lesson-pro-notification" />
        <lesson-pro-confirm />
        <premium-paywall />
        <Offline @detected-condition="handleConnectivityChange"></Offline>
        <span class="offline" v-if="offline"
            >It looks like you don't have an internet connection. or it may be running slow. Connect
            to wifi and try again.</span
        >
    </div>
    <div v-else id="app">
        <div class="page">
            <Offline @detected-condition="handleConnectivityChange"></Offline>
            <span class="offline" v-if="offline"
                >It looks like you don't have an internet connection. or it may be running slow.
                Connect to wifi and try again.</span
            >
            <header class="pageHeader"></header>
            <div id="scroller">
                <pre-loader color="#267962" textColor="#267962" />
            </div>
        </div>
    </div>
</template>

<script>
import Cookie from "js-cookie";
import PreLoader from "@/components/App/Pre-loader";
import LessonProConfirm from "@/components/App/lesson-pro-confirm";
import PremiumPaywall from "@/components/App/premium-paywall";
import AccountSettings from "@/components/Account/Account-settings";
import SponsorAd from "@/components/App/sponsor-ad";
import Offline from "v-offline";
export default {
    name: "app",
    components: {
        Offline,
        PreLoader,
        AccountSettings,
        SponsorAd,
        LessonProConfirm,
        PremiumPaywall,
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    watch: {
        user() {
            this.tryShowLaunchPaywall();
        },
        $route() {
            this.tryShowLaunchPaywall();
        },
    },
    mounted() {
        this.launchPaywallTimer = setTimeout(() => {
            this.launchPaywallDelayElapsed = true;
            this.tryShowLaunchPaywall();
        }, 7000);
    },
    beforeDestroy() {
        if (this.launchPaywallTimer) {
            clearTimeout(this.launchPaywallTimer);
        }
    },
    created() {
        // Remove all viewport meta tags

        this.$nextTick(() => {
            setTimeout(() => {
                var metaTag = document.createElement("meta");
                metaTag.name = "viewport";
                metaTag.content =
                    "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover";
                document.getElementsByTagName("head")[0].appendChild(metaTag);
                console.log("loaded");
            }, 100);
        });

        this.oWebViewInterface.on("sendPushToken", (eventData) => {
            this.hello = eventData;
        });

        this.oWebViewInterface.on("productsSent", (eventData) => {
            this.$store.state.subscriptions = eventData;
            console.log("products sent");
            console.log(eventData);
        });

        this.oWebViewInterface.on("loggedIn", (data) => {
            // this.$router.push({name:'Home'});
            if (data.api_token) {
                Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, data.api_token);
                if (this.$root.redirectTo) {
                    this.$router.push(this.$root.redirectTo);
                } else {
                    this.$router.push({ name: "Home" });
                }
            }
        });

        this.oWebViewInterface.on("redirectTo", (redirectTo) => {
            console.log("redirecting to " + redirectTo);
            this.$router.push(redirectTo);
        });

        this.oWebViewInterface.on("subscribedToApp", () => {
            // Refetch the user so has_premium (and other subscription state) is server truth; the paywall unlocks in place.
            this.$store.dispatch("getUser");
        });
    },
    data() {
        return {
            offline: false,
            oWebViewInterface: window.nsWebViewInterface,
            hello: "not recieved",
            products: [],
            redirectTo: null,
            launchPaywallTimer: null,
            launchPaywallDelayElapsed: false,
            launchPaywallShown: false,
        };
    },
    methods: {
        handleConnectivityChange(status) {
            console.log(status);
            // this.offline = (!status) ? true : false
            this.offline = false;
        },
        tryShowLaunchPaywall() {
            if (
                this.launchPaywallShown ||
                !this.launchPaywallDelayElapsed ||
                !this.user ||
                this.user.has_premium ||
                this.user.type !== "player" ||
                this.$route.meta.isAuthPage ||
                this.$route.meta.isSubscribePage
            ) {
                return;
            }

            this.launchPaywallShown = true;
            this.$premiumPaywall({
                onSubscribe: (payload) => {
                    this.$premiumPaywallSubscribe(payload);
                },
            });
        },
    },
};
</script>

<style lang="scss">
@import "scss/components/notifications", "scss/components/auth", "scss/components/navigation",
    "scss/components/form2", "scss/components/form3", "scss/components/select",
    "scss/components/responsive", "scss/components/table", "scss/components/login";

@import "https://use.typekit.net/efu4trn.css";

.cool-lightbox-toolbar {
    top: env(safe-area-inset-bottom) !important;
}
* {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.clear {
    display: block;
    clear: both;
}
html {
    position: fixed;
    overflow: hidden;
    top: env(safe-area-inset-top) !important;
    bottom: 0;
    //min-height: -webkit-fill-available;
    height: 100%;

    // height: calc(100% + env(safe-area-inset-bottom));
    //padding-bottom: - env(safe-area-inset-bottom);
    //overflow: hidden;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    //-webkit-overflow-scrolling: touch;
    //min-height: -webkit-fill-available;
    //background:#61c45c;
}
body {
    height: 100%;

    height: calc(100% + env(safe-area-inset-bottom));
    //padding-bottom: - env(safe-area-inset-bottom);
    //overflow: hidden;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    //-webkit-overflow-scrolling: touch;
    //min-height: -webkit-fill-available;
    //background:#61c45c;
}

.offline {
    position: fixed;
    top: 0px;
    left: 0px;
    padding: 20px;
    background: $red;
    width: 100%;
    z-index: 50000;
    line-height: 1.5;
    color: white;
    text-align: center;
}
body[orient="portrait"] {
    min-height: 540px;
}
#app {
    //height:100%;
    //min-height: -webkit-fill-available;
    font-family: canada-type-gibson, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    //overflow:hidden;
}
.main {
    //  position: absolute;
    //top:0px;
    //  width: 100%;
    //  height: calc(100vh - 90px);
    //overflow: scroll;
}
.pageHeader {
    height: 362px;
    //background-image:url('./assets/headers/profile.png');
    background: linear-gradient(135deg, #89b5bb 0%, #8d9845 100%);
    img {
        object-fit: cover;
        width: 100%;
    }
    width: 100%;
    position: fixed;
    top: 0px;
    top: env(safe-area-inset-top) !important;
    padding-bottom: 107.8%;

    &.rounded {
        &:after {
            content: "";
            width: 100%;
            height: 29px;
            background: white;
            display: block;
            position: absolute;
            bottom: 0px;
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
        }
    }
    &.darken {
        &:before {
            content: "";
            width: 100%;
            height: 100%;
            background: rgba(38, 121, 98, 0.7);
            display: block;
        }
    }
}
#scroller {
    background: white;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    width: 100%;
    margin-top: calc(362px - 20px);
    padding: 30px 15px 110px 15px;
    position: absolute;
    margin-bottom: 100px;
    min-height: 362px;

    &.small {
        //margin-top:calc(254px - 20px);
        //min-height:254px;
    }

    .pageHeaderIntro {
        position: absolute;
        width: calc(100% - 15px);
        top: -50px;
        color: white;
        &.higher {
            top: -95px;
        }
        .icon {
            position: absolute;
            right: 16px;
            top: 2px;
            width: 34px;
            &.small {
                width: 20px;
                margin-top: -5px;
            }
        }
        h1 {
            font-size: 32px;
            margin-bottom: 20px;
        }
    }
    .title {
        color: $green_0;
        position: relative;
        margin-bottom: 10px;
        .icon {
            position: absolute;
            right: 0px;
            top: -5px;
        }
    }
}
.scroller2 {
    width: calc(100% - 20px);
    background: $grey;
    position: absolute;
    margin: 10px;
    margin-top: 80px;
    padding: 20px;
    padding-top: 35px;
    border-radius: 12px;
    padding-bottom: 110px;
    min-height: calc(100vh - 90px);
    header {
        position: relative;
        .links {
            position: absolute;
            right: 0px;
            top: 0px;
            li {
                display: inline-block;
                margin-left: 10px;
                a {
                    color: $green_0;
                }
                button {
                    appearance: none;
                    background: none;
                    color: $green_1;
                    border: 0px;
                    &:focus {
                        outline: 0;
                    }
                }
            }
        }
    }
    &.green {
        background: $green_2;
    }
    &.green_dark {
        background: $green_0;
        h2 {
            color: white;
        }
    }
    &.dark_blue {
        background: $darkBlue;
        h2 {
            color: white;
        }
    }
    &.dark {
        background: $darkGrey_0;
        h2 {
            color: white;
        }
    }
    h2 {
        font-size: 22px;
        color: $green_0;
        margin-bottom: 20px;

        &.small {
            width: calc(100% - 30px);
        }
    }
}

.copy {
    p {
        margin-bottom: 20px;
        line-height: 1.5;
        &:last-of-type {
            margin-bottom: 0px;
        }
        overflow-wrap: break-word;
        word-wrap: break-word;
        -ms-word-break: break-all;
        word-break: break-all;
        word-break: break-word;
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
    }
}
.info {
    background: $green_light;
    padding: 20px;
    padding-top: 14px;
    padding-bottom: 14px;
    border-radius: $radius;
    display: block;
    margin-bottom: 20px;
    color: $green_0;
    line-height: 1.5;
    font-size: 14px;
    min-height: 52px;
    &.tip {
        background: $green_2;
    }
    &.mb10 {
        margin-bottom: 10px;
    }
    &.white {
        background: white;
    }
    &.small {
        display: inline-block;
        height: 40px;
        padding-left: 23px;
        padding-right: 23px;
        min-height: 40px;
        padding-top: 9px;
    }
    &.large {
        font-size: 16px;
    }
    &.error {
        background: $red;
        color: white;
        margin-bottom: 10px;
        a {
            color: white;
        }
    }
    strong {
        font-weight: bold;
    }
}

.button {
    display: block;
    padding: 17px;
    color: white;
    font-size: 16px;
    border: 0px;
    width: 100%;
    background: $green_1;
    border-radius: 12px;
    text-decoration: none;
    position: relative;
    appearance: none;
    padding-top: 18px;
    padding-bottom: 18px;
    height: 52px !important;
    font-family: canada-type-gibson, sans-serif;
    .icon {
        position: absolute;
        right: 15px;
        top: 15px;
        width: 18px;
    }
    &.left {
        text-align: left;
    }
    &.half {
        width: calc(50% - 10px);
    }
    &:hover {
        background: adjust-hue($green_1, 20deg);
        cursor: pointer;
    }
    &:focus {
        outline: 0;
    }
    &:disabled {
        outline: 0;
        background: silver;
        color: #5e5e5e;
    }
    &.red {
        background: $red;
        &:hover {
            background: adjust-hue($red, 20deg);
        }
    }
    &.dark {
        background: $green_0;
        &:hover {
            background: adjust-hue($green_0, 20deg);
        }
    }

    &.greenLight {
        background: $green_2;
        color: $green_0;
        &:hover {
            background: adjust-hue($green_2, 20deg);
        }
    }

    &.arrowRight {
        img {
            float: right;
            margin-top: 2px;
        }
    }

    .arrow {
        float: right;
        margin-top: 2px;
    }

    &.light {
        background: $green_light;
        color: $green_0;
        &:hover {
            background: adjust-hue($green_light, 20deg);
        }
    }

    &.small {
        font-size: 0.9rem;
        text-align: left;
        padding: 12px;
        .icon {
            width: 20px;
            top: 8px;
        }
    }

    &.left {
        text-align: left;
    }

    &.center {
        text-align: center;
    }

    &.half {
        width: calc(50% - 5px);
        display: inline-block;
        &:first-of-type {
            margin-right: 10px;
        }
    }
    &.alignLeft {
        text-align: left;
    }

    &.mb {
        margin-bottom: 20px;
        display: block;
    }
    &.mb10 {
        margin-bottom: 10px;
        display: block;
    }
    &.mb20 {
        margin-bottom: 10px;
        display: block;
    }
    &.mb30 {
        margin-bottom: 30px;
        display: block;
    }

    &.cancel {
        background: $red;
        &:hover {
            background: adjust-hue($red, 20deg);
        }
    }
}
a.button {
    padding-top: 18px;
    padding-bottom: 18px;
}
button.button {
    padding-top: 17px;
    padding-bottom: 17px;
}
.capitalise {
    text-transform: capitalize;
}
#tasks {
    margin-top: 30px;
    &:after {
        content: "";
        display: block;
        clear: both;
    }
    li {
        float: left;
        width: calc(50% - 5px);
        background: $green_2;
        margin-bottom: 10px;
        border-radius: $radius;
        position: relative;
        &:nth-child(odd) {
            margin-right: 10px;
        }

        img {
            position: absolute;
            top: 22px;

            &.plus {
                right: 16px;
                top: auto;
                bottom: 20px;
            }
        }

        .icon {
            position: absolute;
            bottom: 10px;
            right: 10px;
        }

        a {
            width: 100%;
            height: 100%;
            text-decoration: none;
            color: $green_0;
            display: block;
            padding: 20px;
            padding-top: 50px;
        }

        &:nth-of-type(2) {
            background: $green_1;
            a {
                color: white;
            }
        }
        &:nth-of-type(3) {
            background: $green_0;
            a {
                color: white;
            }
        }
        &:nth-of-type(4) {
            background: $green_3;
        }

        &:nth-of-type(5) {
            background: $darkGrey_1;
            a {
                color: white;
            }
        }
        &:nth-of-type(6) {
            background: white;
            a {
                color: $green_0;
            }
        }
    }
}
.contextMenu {
    width: 200px;
    li {
        margin-bottom: 5px;
        a,
        .box {
            display: block;
            background: white;
            padding: 15px;
            text-decoration: none;
            border-radius: $radius;
            box-shadow: 0px 6px 10px rgb(0 0 0 / 10%) !important;
            font-size: 14px;
            color: $green_0;

            &:hover,
            &:active {
                background: $green_0;
                color: white;
            }
        }
    }
}
.vue__time-picker {
    display: unset !important;
    input[type="text"] {
        height: 61px !important;
    }
}

#nprogress .bar {
    background: $green_1 !important;
}

#keyReminders {
    border-radius: 12px;
    background: $green_2;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    position: relative;
    .title {
        display: block;
        margin-bottom: 10px;
        margin-top: 10px;
        color: $green_0;
        font-weight: 400;
        font-style: normal;
    }
    ul {
        li {
            padding: 10px 0px;
            border-bottom: 1px solid $grey;
            position: relative;
            .icon {
                position: absolute;
                right: 0px;
                top: 17px;
            }
        }
    }
    .chevronDown {
        margin: 0 auto;
        width: 30px;
        display: block;
        margin-top: 10px;
    }
}

.datePicker {
    border: 0px !important;
    width: 100%;
    border-radius: 12px;
    box-shadow: 0px 6px 10px rgb(0 0 0 / 10%);
}
select.button {
    padding: 15px 20px !important;
}
.feather-chevron-right {
    width: 32px !important;
    right: 5px !important;
}

.datePicker {
    margin-bottom: 20px;
    display: block;
    width: 100%;
    .vc-weekday,
    .vc-title {
        font-weight: 400 !important;
        font-size: 14px !important;
        color: #444547 !important;
        font-family: canada-type-gibson, sans-serif !important;
    }
    .vc-day-content {
        font-weight: 400 !important;
        font-size: 14px !important;
        font-family: canada-type-gibson, sans-serif !important;
    }
    .vc-title {
        color: $green_0 !important;
        text-transform: uppercase !important;
        margin-bottom: 20px !important;
    }
    .vc-arrow {
        background: none !important;
    }
    .vc-day {
        padding-top: 1px !important;
        padding-bottom: 3px !important;
        margin: 1px !important;
    }

    .vc-day-content {
        transform: translateY(1px);
        //background:white!important;
        width: 40px !important;
        height: 40px !important;
        border-radius: 8px !important;
        //color:white!important;
        &.available {
            background: #eff5f2 !important;
            color: #444547 !important;
        }
        &.booked {
            background: #baf8e1 !important;
            color: #444547 !important;
        }
        &.selected {
            color: white !important;
        }
    }
    .vc-day-content:hover {
        background: none !important;
    }
    .vc-highlight {
        height: 40px !important;
        width: 40px !important;
        border-radius: 8px !important;
        background: #60c45c !important;
        border: 0px !important;
        color: white !important;

        //height:26px!important;
    }
    .vc-highlights {
        background: transparent !important;
        border-radius: 0px !important;
        border-radius: 8px !important;
    }

    .vc-highlights + .vc-day-content {
        color: white !important;

        &.available {
            background: #eff5f2 !important;
            color: #444547 !important;
        }
        &.booked {
            background: #baf8e1 !important;
            color: #444547 !important;
        }
        &.selected {
            color: white !important;
        }
    }
    /*
  .vc-highlights{
    background: #61c45c!important;
    border-radius: 0px!important;
    border-radius: 8px!important;
  }
  .vc-day-content:hover{
    background:none!important;
  }

  .vc-highlights + .vc-day-content{
    color:white!important;
  }
  */

    .is-disabled {
        color: #eff5f2 !important;
    }
    svg path {
        color: #267962 !important;
    }
    .is-today {
        .vc-day-content {
            background: $green_0 !important;
            border-radius: 0px !important;
            border-radius: 8px !important;
        }

        span {
            color: white !important;
        }
    }
}
</style>
